import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'
import { audioMessageExtraReducers } from '@store/reducres/audioMessage.reducers'

export const audioNewsUrl = 'audio-message'

export interface AudioMessageModel extends DjangoModel {
  audioId: EntityId
  transcription: string
  beginningWords?: string
  endingWords?: string
  used: string[]
  note: string
  name: string
}

const {
  slice: audioNewsSlice,
  thunks: audioNewsThunks,
  adapter: audioNewsAdapter,
  selectors,
} = createGenericSlice<AudioMessageModel>(
  'audioMessage',
  audioNewsUrl,
  {},
  audioMessageExtraReducers
)

export const audioNewsAdapterExport = audioNewsAdapter

export const {
  fetchAll: fetchAllAudioMessages,
  create: createAudioMessage,
  update: updateAudioMessage,
  delete: deleteAudioMessage,
} = audioNewsThunks

export const {
  selectAll: selectAllAudioMessages,
  selectById: selectAudioMessageById,
} = audioNewsAdapter.getSelectors<RootState>(
  (state: RootState) => state.audioMessage
)

export const { removeAll: clearAllAudioMessages } = audioNewsSlice.actions

export const {
  selectLoading: selectAudioNewsLoading,
  selectIsIdInProgress: selectIsAudioNewsIdInProgress,
  selectError: selectAudioNewsError,
} = selectors

export default audioNewsSlice.reducer
